var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisclaimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0zm0 18.907c-4.911 0-8.907-3.996-8.907-8.907S5.09 1.093 10 1.093 18.907 5.09 18.907 10 14.91 18.907 10 18.907zM10 6a.667.667 0 10.001 1.335A.667.667 0 0010 6zm-.61 3.314a.61.61 0 011.22 0v4.261a.61.61 0 01-1.22 0v-4.26z",
    fill: "#fff"
  })));
}
export default SvgDisclaimer;